import { ChangeEvent } from "react";
import { FormGroup } from "react-bootstrap";
import { CSSProperties } from "styled-components";

import SelectOption from "../model/SelectOption";
import AutocompleteStyles from "../styles/components/AutocompleteStyles";

const {
    StyledLabel,
    StyledFormSelectFloatLabel,
    StyledFormSelect,
    StyledFormGroup,
} = AutocompleteStyles;

interface AutocompleteFloatLabelProps {
    // eslint-disable-next-line react/no-unused-prop-types
    options: SelectOption[];
    selected?: SelectOption[] | undefined;
    label?: string;
    labelSecondary?: boolean;
    placeholder?: string;
    disabled?: boolean;
    style?: CSSProperties;
    typeForm?: "default" | "floatLabel";
    onChange: (selected: SelectOption[]) => void;
    onInputChange?:
        | ((text: string, event: ChangeEvent<HTMLInputElement>) => void)
        | undefined;
    className?: string;
}

function AutocompleteFloatLabel(props: AutocompleteFloatLabelProps) {
    const styleGroup: CSSProperties = {
        width: "100%",
        maxWidth: "735px",
        marginBottom: "24px",
    };

    const filterByFields = ["value", "label"];

    return (
        <>
            {(!props.typeForm || props.typeForm === "floatLabel") && (
                <StyledFormGroup
                    style={props.style || styleGroup}
                    className={props.className || ""}
                >
                    {props.label && <StyledLabel>{props.label}</StyledLabel>}
                    <StyledFormSelectFloatLabel
                        id="basic-example"
                        onChange={(value: any[]) => props.onChange(value)}
                        onInputChange={props.onInputChange}
                        options={props.options}
                        placeholder={props.placeholder}
                        selected={props.selected}
                        clearButton
                        disabled={props.disabled}
                        paginationText="Mais resultados"
                        emptyLabel="Nenhum resultado encontrado"
                        labelKey={(option: any) => `${option?.label}`}
                        filterBy={filterByFields}
                        renderMenuItemChildren={(item: any) => (
                            <div>
                                {item.label}
                                {props.labelSecondary &&
                                    item.labelSecondary && (
                                        <div>
                                            <small>{item.labelSecondary}</small>
                                        </div>
                                    )}
                            </div>
                        )}
                    />
                </StyledFormGroup>
            )}
            {props.typeForm === "default" && (
                <FormGroup
                    style={props.style || styleGroup}
                    className={props.className || ""}
                >
                    {props.label && <StyledLabel>{props.label}</StyledLabel>}
                    <StyledFormSelect
                        id="basic-example"
                        onChange={(value: any[]) => props.onChange(value)}
                        onInputChange={props.onInputChange}
                        options={props.options}
                        placeholder={props.placeholder}
                        selected={props.selected}
                        clearButton
                        disabled={props.disabled}
                        paginationText="Mais resultados"
                        emptyLabel="Nenhum resultado encontrado"
                        labelKey={(option: any) => `${option?.label}`}
                        filterBy={filterByFields}
                        renderMenuItemChildren={(item: any) => (
                            <div>
                                {item.label}
                                {props.labelSecondary &&
                                    item.labelSecondary && (
                                        <div>
                                            <small>{item.labelSecondary}</small>
                                        </div>
                                    )}
                            </div>
                        )}
                    />
                </FormGroup>
            )}
        </>
    );
}

export default AutocompleteFloatLabel;
